import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import { useFetchActivePartnersQuery } from '../../../features/API/user-api-slice';
import { CardBody, CardTitle, PageTitle } from '../../text';
import Spinner from '../../UI/spinner';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Partners = () => {
  const { t } = useTranslation();
  const { data = [], isFetching } = useFetchActivePartnersQuery();
  const selectedLanguage = useSelector(
    (state) => state.global.selectedLanguage
  );
  const [imageConfiguration, setImageConfiguration] = useState({
    height: '100%',
    width: '100%',
  });
  
  // Function to truncate text
  const truncateText = (text, wordLimit) => {
    if (!text) return '';
    const words = text.split(' ');
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + '...';
  };
  
  var settings = {
    arrows: true,
    dots: true,
    centerMode: false,
    lazyLoad: true,
    swipeToSlide: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return isFetching ? (
    <Spinner />
  ) : (
    <div className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <PageTitle
          name={t('Our Partners')}
          color="red"
          alignment="center"
          mobileAlignment="center"
          additional="mb-8"
        />
        <div className="text-center mb-12">
          <p className="text-gray-600 max-w-2xl mx-auto">
            {t('Together with our valued partners, we create lasting impact and positive change in communities across Rwanda.')}
          </p>
        </div>
        <div className="partners-carousel">
          <Slider {...settings}>
            {data.results.map((partner, index) => (
              <div key={index} className="px-2">
                <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 h-80 flex flex-col mx-2">
                  <div className="flex items-center justify-center mb-6 h-20">
                    <LazyLoadImage
                      className="max-h-16 max-w-full object-contain"
                      effect="blur"
                      placeholderSrc="/images/logo.png"
                      afterLoad={() => {
                        setImageConfiguration({ height: '', width: '' });
                      }}
                      {...imageConfiguration}
                      src={`${process.env.REACT_APP_BACKEND_URL}/images/${partner.image}`}
                      alt={partner.name || 'Partner'}
                    />
                  </div>
                  <div className="flex-1 text-center">
                    <CardTitle 
                      name={partner.name} 
                      alignment="center" 
                      additional="text-lg font-bold text-gray-900 mb-4" 
                    />
                    <CardBody
                      name={truncateText(partner.description[selectedLanguage], 25)}
                      additional="text-sm text-gray-600 leading-relaxed"
                    />
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Partners;
